export class FilingChunk {
  public id: string;
  public title: string;
  public filingDate: Date;
  public chunkId?: number;
  public content?: string;

  constructor(filingChunk: any) {
    this.id = filingChunk.filingId;
    this.title = filingChunk.title;
    this.filingDate = new Date(filingChunk.filingDate);
    this.chunkId = filingChunk.chunkId;
    this.content = filingChunk.content;
  }
}
